import CountryNameMessages from '../components/country-names.messages';
import { TaxIdentifiers } from '../enums/tax-identifiers/tax-identifiers';
import { TaxIdentifierTypes } from '../enums/tax-identifiers/tax-identifiers-types';

export const taxIdentifiersOptionsMap = {
  [TaxIdentifiers.taxIdentifierType.key]: [
    TaxIdentifierTypes.taxTIN,
    TaxIdentifierTypes.taxEIN,
    TaxIdentifierTypes.taxSSN,
    TaxIdentifierTypes.taxVAT,
    TaxIdentifierTypes.taxEORI,
    TaxIdentifierTypes.taxIOSS,
    TaxIdentifierTypes.taxPAN,
    TaxIdentifierTypes.taxVOEC,
    TaxIdentifierTypes.taxUKIMS,
  ],
  [TaxIdentifiers.taxNumber.key]: [],
  [TaxIdentifiers.taxNickname.key]: [],
  [TaxIdentifiers.taxDescription.key]: [],
  [TaxIdentifiers.taxIssuingAuthority.key]: Object.keys(CountryNameMessages).map((countryCode) => ({
    value: countryCode,
    messageDescriptor: CountryNameMessages[countryCode],
  })),
};

export const getTaxIdentifierOptions = (taxIdentifier) => {
  return taxIdentifiersOptionsMap[taxIdentifier.key];
};

export const getSelectedOptionMessageDescriptor = (value, optionSet) =>
  optionSet.find((option) => option.value === value).messageDescriptor;

export const groupByTaxIdType = (taxIdObjs = []) => {
  return taxIdObjs.reduce((acc, taxIdObj) => {
    return {
      ...acc,
      [taxIdObj.type]: [...(acc[taxIdObj.type] || []), taxIdObj.taxIdentifierId],
    };
  }, {});
};
